import styled, { keyframes } from 'styled-components'
import * as DropdownPrimitive from '@radix-ui/react-dropdown-menu'
import { CLIENT_STYLINGS } from '../../../utils/constants'
import { getBorderRadius } from '../../../utils/styleUtils'

// simple fade/scale animations similar to dialog
const fadeIn = keyframes`
  from { opacity: 0; transform: scale(0.95); }
  to { opacity: 1; transform: scale(1); }
`
const fadeOut = keyframes`
  from { opacity: 1; transform: scale(1); }
  to { opacity: 0; transform: scale(0.95); }
`

export const StyledContent = styled(DropdownPrimitive.Content)`
  z-index: 999999999;
  min-width: 8rem;
  background: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.BACKGROUND};
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.FOREGROUND};
  border: 1px solid
    ${props => CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.BORDER};
  border-radius: ${props => getBorderRadius(props, 'md')};
  padding: 4px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.12);
  &[data-state='open'] {
    animation: ${fadeIn} 120ms ease-out forwards;
  }
  &[data-state='closed'] {
    animation: ${fadeOut} 120ms ease-in forwards;
  }
`

export const StyledItem = styled(DropdownPrimitive.Item)`
  cursor: default;
  user-select: none;
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  padding: 6px 8px;
  border-radius: ${props => getBorderRadius(props, 'sm')};
  color: inherit;

  &:focus {
    outline: none;
  }

  &:hover {
    background: ${props =>
      CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.MUTED};
  }

  &[data-disabled='true'] {
    opacity: 0.5;
    pointer-events: none;
  }

  &[data-highlighted='true'] {
    background: ${props =>
      CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.MUTED};
  }

  &[data-variant='destructive'] {
    color: ${props =>
      CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.DESTRUCTIVE};
  }
`

export const IndicatorContainer = styled.span`
  position: absolute;
  left: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 14px;
  height: 14px;
`

export const StyledLabel = styled(DropdownPrimitive.Label)`
  font-size: 13px;
  font-weight: 500;
  padding: 6px 8px;
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.MUTED_FOREGROUND};
`

export const StyledSeparator = styled(DropdownPrimitive.Separator)`
  height: 1px;
  margin: 4px -4px;
  background: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.BORDER};
`

export const StyledSubContent = styled(DropdownPrimitive.SubContent)`
  z-index: 999999999;
  min-width: 8rem;
  background: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.BACKGROUND};
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.FOREGROUND};
  border: 1px solid
    ${props => CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.BORDER};
  border-radius: ${props => getBorderRadius(props, 'md')};
  padding: 4px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.12);
  &[data-state='open'] {
    animation: ${fadeIn} 120ms ease-out forwards;
  }
  &[data-state='closed'] {
    animation: ${fadeOut} 120ms ease-in forwards;
  }
`

export const StyledSubTrigger = styled(DropdownPrimitive.SubTrigger)`
  cursor: default;
  user-select: none;
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  padding: 6px 8px;
  border-radius: ${props => getBorderRadius(props, 'sm')};
  color: inherit;

  &[data-disabled='true'] {
    opacity: 0.5;
    pointer-events: none;
  }

  &[data-highlighted='true'] {
    background: ${props =>
      CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.MUTED};
  }
  &[data-state='open'] {
    background: ${props =>
      CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.MUTED};
  }
  padding-right: 24px;
  position: relative;
`

export const Shortcut = styled.span`
  margin-left: auto;
  font-size: 12px;
  opacity: 0.6;
`
